<script>
    import numeral from 'numeral';
    import AppLayout from '@/layouts/app-layout';
    import EmptyLayout from '@/layouts/empty-layout';
    import LayoutMixin from '@/mixins/layout';
    import { checkUserClockSkewOnce, resetUserClockSkewCheck } from '@/utils/clock-skew';

    export default {
      name: 'PvsInvoiceWeb',
      mixins: [LayoutMixin],
      created() {
        this.$i18n.locale = localStorage.getItem('lang');
        this.$i18n.fallbackLocale = this.$config.fallbackLocale;
        if (!this.$i18n.locale) {
          localStorage.setItem('lang', this.$i18n.locale = this.$config.locale);
        }
        this.$validator.localize(this.$i18n.locale);
        numeral.locale(this.$i18n.locale);
      },
      mounted() {
        this.$nextTick(() => {
          resetUserClockSkewCheck();
          checkUserClockSkewOnce();
        });
        if (this.$store.state.auth.authenticated) {
          // this.$store.dispatch('account/find');
        }
      },
      components: {
        AppLayout,
        EmptyLayout,
      },
    };
</script>



// WEBPACK FOOTER //
// src/app.vue